<ng-container *transloco="let t">
  <div class="flex flex-col gap-3">
    @if (props.label) {
      <p class="font-semibold">
        {{ props.label }}
        <span class="text-red-500" *ngIf="props.required">*</span>
      </p>
    }
    @if (props.description) {
      <div>
        {{ props.description }}
      </div>
    }

    <div class="flex flex-col gap-2 w-full">
      <app-json-editor
        [formControl]="jsonControl"
        (blur)="onBlur()"
        class="json-editor border rounded outline-none border-surface-200 dark:border-surface-700"
        [ngClass]="{
          'ng-invalid': isFieldInvalid(),
          'ng-touched': jsonControl.touched,
          'p-disabled': formControl.disabled,
        }"
        [disabled]="formControl.disabled"
      ></app-json-editor>

      @if (isFieldInvalid()) {
        <div class="text-red-500 text-sm">
          @if (jsonError) {
            {{ jsonError }}
          } @else {
            {{ t("app.formly-types.validationMessages.fieldRequired") }}
          }
        </div>
      }
    </div>
  </div>
</ng-container>
